import { Box, Grid, Stack, styled, Typography } from "@mui/material";

export const ItemBox = styled(Grid)(({ theme }) => ({
  background: "#FFFFFF",
  borderWidth: "0px 2px",
  borderStyle: "solid",
  borderColor: "#858585",
  boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.1)",
  borderRadius: "6px",
  marginTop: "5px",
  height: "93px",
  display: "flex",
  alignItems: "center",
  [theme.breakpoints.down("md")]: {
    height: "180px",
  },
  [theme.breakpoints.down("sm")]: {
    height: "300px",
  },
}));
export const IconBox = styled(Box)(({ theme }) => ({
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-evenly",
  padding: "0px 5%",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-evenly",
  },
}));
export const StackBox = styled(Stack)(({ theme }) => ({
  rowGap: 10,
  alignItems: "flex-start",
  justifyContent: "space-evenly",
  [theme.breakpoints.down("lg")]: {
    rowGap: 15,
  },
  [theme.breakpoints.down("md")]: {
    rowGap: 1,
  },
}));
export const TitleBox = styled(Box)(({ theme }) => ({
  display: "flex",
  columnGap: 5,
  flexDirection: "row",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}));

export const DialogTitle = styled(Typography)({
  fontFamily: "Roboto",
  fontStyle: "normal",
  fontWeight: "600",
  fontSize: "18px",
  lineHeight: "21px",
  textAlign: "center",
  color: "#459B47",
  paddingBottom: "10px",
});
export const SubTitle = styled(Typography)({
  fontFamily: "Dosis",
  fontStyle: "normal",
  fontWeight: "400",
  fontSize: "16px",
  lineHeight: "20px",
  textAlign: "center",
  color: "#7E7E7E",
});
